export default "__VITE_ASSET__DTkQAIEj__"